import App from "./App.svelte";
import { applyTheme } from "./lib/theme/applyTheme.js";
import { getThemeSnapshotSync, loadThemeSettings } from "./lib/theme/themeStore.js";
import { initI18n } from "./i18n/index.js";

// Apply something immediately to avoid a theme flash.
applyTheme(getThemeSnapshotSync());

// Then load the canonical theme from IndexedDB (per-user) and re-apply.
loadThemeSettings().then((settings) => applyTheme(settings)).catch(() => {});

let app;

// i18n must be initialized BEFORE the app mounts.
initI18n()
  .catch(() => {
    // ignore (falls back to default locale)
  })
  .finally(() => {
    app = new App({
      target: document.getElementById("app"),
    });
  });

export default app;
